// components/Accounting/AccountModal.js
import React from 'react'
import { withTranslation } from 'react-i18next'
import Select from "react-select"
import makeAnimated from "react-select/animated"
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormFeedback,
  Row,
  Col,
  Label,
  Input
} from 'reactstrap'

const AccountModal = ({
  isOpen,
  toggle,
  isEdit,
  validation,
  selectedParent,
  selectedTypes,
  parentOptions,
  typesOptions,
  reconciled,
  setReconciled,
  handleSelectParent,
  handleSelectType,
  onClose,
  t
}) => {
  const animatedComponents = makeAnimated()

  return (
    <Modal id='accountModal' size='lg' isOpen={isOpen} toggle={toggle} backdrop={'static'} centered>
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        {isEdit ? t("edit_class_account") : t("create_class_account")}
      </ModalHeader>
      
      <Form className="tablelist-form" autoComplete="off" onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}>
        <ModalBody>
          <input type="hidden" id="id-field" />
          <Row>
            <Col xl={6} sm={12}>
              <div className="mb-3">
                <Label htmlFor="name-field" className="form-label">
                  {t("name")}<span className='text-danger'>*</span>
                </Label>
                <Input
                  name="name"
                  id="name-field"
                  className="form-control"
                  autoComplete="off" 
                  placeholder={t("name")}
                  type="text"
                  validate={{
                    required: { value: true },
                  }}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.name || ""}
                  invalid={
                    validation.touched.name && validation.errors.name ? true : false
                  }
                />
                {validation.touched.name && validation.errors.name ? (
                  <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                ) : null}
              </div>
            </Col>
            
            <Col xl={6} sm={12}>
              <div className="mb-3">
                <Label htmlFor="code-field" className="form-label">
                  {t("code")}<span className='text-danger'>*</span>
                </Label>
                <Input
                  name="code"
                  id="code-field"
                  className="form-control"
                  autoComplete="off" 
                  placeholder={t("code")}
                  type="text"
                  validate={{
                    required: { value: true },
                  }}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.code || ""}
                  invalid={
                    validation.touched.code && validation.errors.code ? true : false
                  }
                />
                {validation.touched.code && validation.errors.code ? (
                  <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                ) : null}
              </div>
            </Col>
            
            <Col xl={12} sm={12}>
              <div className='mb-3'>
                <Label htmlFor="parentClassAccountId-field" className="form-label">
                  {t("parent")}
                </Label>
                <Select
                  name='parentClassAccountId'
                  id='parentClassAccountId-field'
                  value={selectedParent}
                  isMulti={false}
                  isClearable={false}
                  autoComplete="off" 
                  onBlur={validation.handleBlur}
                  onChange={handleSelectParent}
                  options={parentOptions}
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                />
              </div>
            </Col>
            
            <Col xl={12} sm={12}>
              <div className='mb-3'>
                <Label htmlFor="classAccountType-field" className="form-label">
                  {t("account-type")}
                </Label>
                <Select
                  name='classAccountType'
                  id='classAccountType-field'
                  value={selectedTypes}
                  isMulti={false}
                  isClearable={false}
                  autoComplete="off" 
                  onBlur={validation.handleBlur}
                  onChange={handleSelectType}
                  options={typesOptions}
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                />
              </div>
            </Col>

            <Col xl={12} sm={12}>
              <div className="mb-3">
                <Input
                  name="reconciled"
                  id="reconciled-field"
                  type="checkbox"
                  className="mx-2"
                  onChange={(e) => setReconciled(e.target.checked)}
                  checked={reconciled}
                />
                <Label htmlFor="reconciled-field" className="form-label">
                  {t("reconciled")}
                </Label>
              </div>
            </Col>

            <Col xl={12} sm={12}>
              <div>
                <Label htmlFor="description-field" className="form-label">
                  {t("description")}
                </Label>
                <textarea 
                  name="description"
                  className="form-control" 
                  id="description-field" 
                  placeholder={t("enter_description")}
                  rows={3}
                  validate={{
                    required: { value: true },
                  }}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.description || ""}
                  invalid={
                    validation.touched.description && validation.errors.description ? true : false
                  }
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        
        <div className='p-3'>
          <Row className="align-items-center">
            <div className="col-sm">
              <span className='text-danger align-middle'>* : {t("required_fields")}</span>
            </div>
            <div className="col-sm-auto">
              <div className="hstack gap-2 justify-content-end">
                <button type="button" className="btn btn-secondary" onClick={onClose}>
                  {t("close")}
                </button>
                <button type="submit" className="btn btn-success">
                  {isEdit ? t("update") : t("save")}
                </button>
              </div>
            </div>
          </Row>
        </div>
      </Form>
    </Modal>
  )
}

export default withTranslation()(AccountModal)